// TODO...

const note_story_from_author_subscription = {
  key: "note_story_from_author_subscription",
  label_data: "new story from author subscription",
  label_detail: "A story is published by an author I'm subscribed to.",
  // label_note: (user) => userLabel(user) + " published a new story.",
  // link: ({ slug }) => `/story/${slug}`,
};

module.exports = note_story_from_author_subscription;
